import React from 'react';
import { Collapse } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import './finance-reconciliation.css';

export default function FinanceHelpPanel({
  help,
  defaultOpen = false,
  className = '',
}) {
  if (!help || typeof help !== 'object') return null;

  const whyDiffer = Array.isArray(help.why_numbers_differ) ? help.why_numbers_differ : [];
  const tips = Array.isArray(help.tips) ? help.tips : [];
  const hasContent =
    help.intro
    || help.compare_intro
    || help.summary_heading
    || whyDiffer.length > 0
    || tips.length > 0;

  if (!hasContent) return null;

  return (
    <Collapse
      bordered={false}
      className={`finance-help-panel ${className}`.trim()}
      defaultActiveKey={defaultOpen ? ['help'] : []}
      items={[
        {
          key: 'help',
          label: (
            <span className="finance-help-panel__label">
              <InfoCircleOutlined />
              {help.title || 'About this report'}
            </span>
          ),
          children: (
            <div className="finance-help-panel__body">
              {help.period_label || help.organization_label ? (
                <p className="finance-help-panel__context">
                  {[help.organization_label, help.period_label].filter(Boolean).join(' · ')}
                </p>
              ) : null}
              {help.intro ? <p className="finance-help-panel__intro">{help.intro}</p> : null}
              {help.summary_heading ? (
                <h4 className="finance-help-panel__heading">{help.summary_heading}</h4>
              ) : null}
              {help.compare_heading ? (
                <h4 className="finance-help-panel__heading">{help.compare_heading}</h4>
              ) : null}
              {help.compare_intro ? (
                <p className="finance-help-panel__intro">{help.compare_intro}</p>
              ) : null}
              {whyDiffer.length > 0 ? (
                <ul className="finance-help-panel__list">
                  {whyDiffer.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}
              {tips.length > 0 ? (
                <>
                  <h4 className="finance-help-panel__heading">Tips</h4>
                  <ul className="finance-help-panel__list finance-help-panel__list--tips">
                    {tips.map((tip) => (
                      <li key={tip}>{tip}</li>
                    ))}
                  </ul>
                </>
              ) : null}
            </div>
          ),
        },
      ]}
    />
  );
}
